import { API } from "@/main.js";

const state = {
  companies: {
    type1: [],
    type2: []
  },
  companyList: [],
  companyTypes: [
    { id: "2", label: "SP" },
    { id: "3", label: "SC" }
  ]
};

const getters = {
  companies_type1: state => state.companies.type1,
  companies_type2: state => state.companies.type2,
  company_types: state => state.companyTypes,
  company_type: state => id => {
    return state.companyTypes.filter(company => company.id === id);
  }
};

const mutations = {
  GET_COMPANIES_OF_TYPE_1(state, data) {
    state.companies.type1 = data;
  },
  GET_COMPANIES_OF_TYPE_2(state, data) {
    state.companies.type2 = data;
  },
  SET_ALL_COMPANIES(state, data) {
    state.companyList = data;
  }
};

const actions = {
  fetchAllCompanies({ commit }, queryParams = null) {
    return new Promise((resolve, reject) => {
      API.company.getAll(
        queryParams,
        "roles",
        result => {
          resolve(result.data);
          commit("SET_ALL_COMPANIES", result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchCompanyByID({ commit }, { id, includes }) {
    return new Promise((resolve, reject) => {
      API.company.getByID(
        id,
        includes,
        resp => {
          resolve(resp.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  addCompany({ commit }, companyData) {
    return new Promise((resolve, reject) => {
      API.company.create(
        companyData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editCompanyByID({ commit }, { id, updatedData }) {
    return new Promise((resolve, reject) => {
      API.company.edit(
        id,
        updatedData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteCompanyByID({ commit }, id) {
    return new Promise((resolve, reject) => {
      API.company.delete(
        id,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_COMPANIES_OF_TYPE_1({ commit }) {
    return new Promise((resolve, reject) => {
      API.company.getByType(
        1,
        resp => {
          commit("GET_COMPANIES_OF_TYPE_1", resp.data.data);
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  GET_COMPANIES_OF_TYPE_2({ commit }) {
    return new Promise((resolve, reject) => {
      API.company.getByType(
        2,
        resp => {
          commit("GET_COMPANIES_OF_TYPE_2", resp.data.data);
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchUsersByCompanyID({ commit }, companyID) {
    return new Promise((resolve, reject) => {
      API.company.getAssociatedUsers(
        companyID,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchCompanyPermissionsByUserType({ commit }, { companyID, userType }) {
    return new Promise((resolve, reject) => {
      API.company.getCompanyPermissionsByUserType(
        companyID,
        userType,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/companies.js